var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayOnDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_3319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1537 5.81387C1.8335 6.51007 1.8335 7.30209 1.8335 8.88614V13.8333C1.8335 16.0331 1.8335 17.1331 2.51691 17.8165C3.15575 18.4553 4.15854 18.497 6.0835 18.4997V12.6667C6.0835 11.47 7.05355 10.5 8.25016 10.5H11.7502C12.9468 10.5 13.9168 11.47 13.9168 12.6667V18.4997C15.8418 18.497 16.8446 18.4553 17.4834 17.8165C18.1668 17.1331 18.1668 16.0331 18.1668 13.8333V8.88614C18.1668 7.30209 18.1668 6.51007 17.8466 5.81387C17.5264 5.11767 16.9251 4.60223 15.7224 3.57134L14.5557 2.57134C12.3818 0.708026 11.2949 -0.223633 10.0002 -0.223633C8.70543 -0.223633 7.61849 0.708026 5.44462 2.57134L4.27796 3.57134C3.07526 4.60223 2.47391 5.11767 2.1537 5.81387ZM11.9168 18.4999V12.6667C11.9168 12.5746 11.8422 12.5 11.7502 12.5H8.25016C8.15812 12.5 8.0835 12.5746 8.0835 12.6667V18.4999H11.9168Z",
    fill: "#CC4941"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_3319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayOnDelivery);
export default __webpack_public_path__ + "static/media/pay_on_delivery.e8b532cfcfc08e73da7606319cdd6e14.svg";
export { ForwardRef as ReactComponent };